import React from 'react'
import { Link, useRouteMatch } from 'react-router-dom'
import Icon from 'components/Icon'
import { FormattedMessage, useIntl } from 'react-intl'
import messages from "./messages";

const ConfirmRecover = ({ logo, name, url, onSubmit, loading }) => {
  const { params: { token } } = useRouteMatch()
  const { formatMessage } = useIntl()

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <img className="mx-auto h-12 w-auto" src={logo} alt={name} />
          <p className="mt-12 text-center text-sm text-gray-600">
            <FormattedMessage {...messages.title}/>
          </p>
        </div>
        <form className="mt-8 space-y-6" onSubmit={onSubmit}>
          <input type="hidden" name="token" value={token} />

          <div className="rounded-sm shadow-sm -space-y-px">
            <div>
              <label for="password" className="sr-only">Password</label>
              <input id="password" name="password" type="password" autocomplete="password" required className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-sm focus:outline-none focus:ring-primary focus:border-primary focus:z-10 sm:text-sm" placeholder={formatMessage(messages.password)} />
            </div>
            <div>
              <label for="password-repeated" className="sr-only"><FormattedMessage {...messages.repeatPassword}/></label>
              <input id="password-repeated" name="password-repeated" type="password" autocomplete="current-password-repeated" required className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-sm focus:outline-none focus:ring-primary focus:border-primary focus:z-10 sm:text-sm" placeholder={formatMessage(messages.repeatPassword)}/>
            </div>
          </div>

          <div>
            <button disabled={loading} type="submit" className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded text-white bg-primary hover:bg-primary-darker focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary">
              <span className="absolute left-0 inset-y-0 flex items-center pl-3">
                <Icon icon="lock" className="text-primary-darker" />
              </span>

              { loading ? formatMessage(messages.loading) : formatMessage(messages.finish) }
            </button>
          </div>
        </form>

        <div className="mt-6">
          <div className="relative">
            <div className="absolute inset-0 flex items-center">
              <div className="w-full border-t border-gray-300"></div>
            </div>
            <div className="relative flex justify-center text-sm">
              <span className="px-2 bg-gray-50 text-gray-500">
                <FormattedMessage {...messages.needHelp}/>
              </span>
            </div>
          </div>

          <a href="mailto:mail@voicearchive.com">
            <button type="button" className="mt-4 w-full flex justify-center items-center space-x-2 py-2 px-4 border border-gray-200 hover:border-gray-400 text-sm font-medium rounded focus:outline-none focus:ring-2 focus:ring-offset-2 focus:gray-400 text-gray-500" title={formatMessage(messages.reachOut)}>
              <span><FormattedMessage {...messages.reachOut}/></span>
              <Icon icon="external-link" />
            </button>
          </a>
        </div>
      </div>
    </div>
  )
}

export default ConfirmRecover
